import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaAndroid, FaApple, FaGlobe } from "react-icons/fa";

const AppDownloadPrompt = ({ show, onClose, onSelectOption }) => {
  /**
   * Handles option selection
   * @param {string} option - 'android' | 'ios' | 'web'
   */
  const handleSelection = (option) => {
    if (onSelectOption) onSelectOption(option);
    onClose();
  };

  return (
    // <Modal
    //   show={show}
    //   onHide={onClose}
    //   centered
    //   backdrop="static"
    //   keyboard={false}
    //   aria-labelledby="app-download-prompt-title"
    // >
    //   <Modal.Header closeButton>
    //     <Modal.Title id="app-download-prompt-title">
    //       Continue Your Order
    //     </Modal.Title>
    //   </Modal.Header>

    //   <Modal.Body className="text-center">
    //     <p className="mb-4">
    //       Choose how you'd like to complete your order:
    //     </p>

    //     <div className="d-flex flex-column gap-3">
    //       <Button
    //         variant="success"
    //         size="lg"
    //         onClick={() => handleSelection("android")}
    //       >
    //         Continue on Android App
    //       </Button>

    //       <Button
    //         variant="primary"
    //         size="lg"
    //         onClick={() => handleSelection("ios")}
    //       >
    //         Continue on iOS App
    //       </Button>

    //       <Button
    //         variant="secondary"
    //         size="lg"
    //         onClick={() => handleSelection("web")}
    //       >
    //         Continue on Web
    //       </Button>
    //     </div>
    //   </Modal.Body>

    //   <Modal.Footer className="justify-content-center">
    //     <small className="text-muted">
    //       You can always switch platforms later.
    //     </small>
    //   </Modal.Footer>
    // </Modal>


       <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      aria-labelledby="app-download-prompt-title"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title id="app-download-prompt-title" className="w-100 text-center fw-semibold">
          Continue Your Order
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="mb-4 text-muted">
          Choose how you'd like to complete your order:
        </p>

        {/* Android + iOS row */}
        <div className="d-flex justify-content-center gap-3 mb-4 flex-wrap">
          <Button
            variant="success"
            size="lg"
            className="d-flex align-items-center justify-content-center gap-2 px-4"
            onClick={() => handleSelection("android")}
          >
            <FaAndroid size={24} />
            Android App
          </Button>

          <Button
            variant="dark"
            size="lg"
            className="d-flex align-items-center justify-content-center gap-2 px-4"
            onClick={() => handleSelection("ios")}
          >
            <FaApple size={24} />
            iOS App
          </Button>
        </div>

        {/* Continue on Web (below row) */}
        <div className="d-flex justify-content-center">
          <Button
            variant="secondary"
            size="lg"
            className="d-flex align-items-center justify-content-center gap-2 px-4"
            onClick={() => handleSelection("web")}
          >
            <FaGlobe size={22} />
            Continue on Web
          </Button>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 justify-content-center">
        {/* <small className="text-muted">
          You can always switch platforms later.
        </small> */}
      </Modal.Footer>
    </Modal>
  );
};

export default AppDownloadPrompt;
